export const anyTemplateOption = {
  label: "Any template",
  value: null,
};
